<template>
  <div class="feed-page">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="list-hero">
            <p class="list-crumb">Logs</p>
            <h1 class="list-title">Registro de Actividad</h1>
            <p class="list-subtitle">
              Historial de acciones realizadas en el sistema TRANSIT.
            </p>
          </div>
        </v-flex>

        <v-flex xs12>
          <v-card class="feed-card">
            <div class="feed-toolbar">
              <span class="feed-chip">
                <v-icon small class="feed-chip__icon">history</v-icon>
                {{ logs.length }} registro(s)
              </span>
            </div>
            <v-divider></v-divider>

            <div v-if="logs.length > 0" class="feed-list">
              <div v-for="(item, index) in logs" :key="index" class="feed-item">
                <div class="feed-item__icon feed-item__icon--log">
                  <v-icon>receipt_long</v-icon>
                </div>
                <div class="feed-item__body">
                  <p class="feed-item__title">
                    {{ item.userComment || 'Sin descripción' }}
                  </p>
                  <div class="feed-item__meta">
                    <span v-if="item.action" class="feed-item__action">
                      {{ item.action }}
                    </span>
                  </div>
                </div>
                <div class="feed-item__time">{{ item.dateComment }}</div>
              </div>
            </div>

            <div v-else class="feed-empty">
              <v-icon class="feed-empty__icon">history_toggle_off</v-icon>
              <p class="feed-empty__title">
                Bienvenido al Sistema de Logs de TRANSIT
              </p>
              <p class="feed-empty__text">Aún no hay registros.</p>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logs: [],
    }
  },
  created() {
    this.$store.dispatch('dashboard/getLogs').then(response => {
      if (response.data && response.data.logs) {
        this.logs = response.data.logs.reverse()
      }
    })
  },
}
</script>

<style scoped src="./feed-list.css"></style>
